const Q = require('q');
const _ = require('underscore');
const utilities = require('utilities');
const model = require('model/model');
const assignmentService = require('services/assignmentService');

const sortNodes = nodes => {
	let sorted = [];
	if (nodes && nodes.length) {
		sorted = utilities.sortObjects(nodes, 'ts');
	}
	return sorted;
};

const convertNodes = map => {
	let nodes = Object.keys(map).map(id => {
		let node = map[id];
		let root = !node.p;
		return {
			id,
			root,
			word: node.w,
			text: node.t,
			parentId: node.p,
			linkText: node.l
		};
	});
	return sortNodes(nodes);
};

const getGraphicOrganizer = aid => {
	let prms = Q.reject();
	if (aid) {
		return assignmentService
			.readGraphicOrganizer({
				aid
			})
			.then(result => {
				let nodes = null;
				if (!result) {
					nodes = [];
				} else if (result && result.n) {
					nodes = convertNodes(result.n);
				}
				let data = {
					nodes
				};
				model.set('graphicOrganizer', data);
				return data;
			});
	}
	return prms;
};

const createNode = (aid, parentId, word, text, linkText) => {
	let prms = Q.reject();
	let p = parentId;
	let w = word;
	let t = text;
	let l = linkText;
	if (aid && w) {
		prms = assignmentService
			.createGraphicOrganizerNode({
				aid,
				p,
				w,
				t,
				l
			})
			.then(result => {
				let node = null;
				if (result && result.updated && result.updated.n) {
					let nodes = convertNodes(result.updated.n);
					if (nodes && nodes.length === 1) {
						node = nodes[0];
					}
				}

				let org = model.get('graphicOrganizer');

				if (node && org && Array.isArray(org.nodes)) {
					let nodes = [...org.nodes, node];
					nodes = sortNodes(nodes);
					org = _.assign({}, org, { nodes });

					model.set('graphicOrganizer', org);
				} else {
					return Q.reject('Creation Failed');
				}

				return node;
			});
	}
	return prms;
};

const updateNode = (aid, id, parentId, word, text, linkText, root) => {
	let prms = Q.reject();
	let p = parentId;
	let w = word;
	let t = text;
	let l = linkText;
	let nid = id;
	if (aid && id) {
		prms = assignmentService
			.updateGraphicOrganizerNode({
				aid,
				nid,
				p,
				w,
				t,
				l
			})
			.then(result => {
				let node = null;
				if (result && result.updated && result.updated.n) {
					let nodes = convertNodes(result.updated.n);
					if (nodes && nodes.length === 1) {
						node = nodes[0];
					}
				}

				let org = model.get('graphicOrganizer');

				if (node && org && Array.isArray(org.nodes)) {
					let nidx = -1;
					org.nodes.some((n, idx) => {
						if (n.id === id) {
							nidx = idx;
							return true;
						}
						return false;
					});
					if (nidx !== -1) {
						let nodes = _.assign([], org.nodes, {
							[nidx]: node
						});
						org = _.assign({}, org, {
							nodes
						});
						model.set('graphicOrganizer', org);
					}
				} else {
					return Q.reject('Update Failed');
				}

				return node;
			});
	}
	return prms;
};

const deleteNode = (aid, id) => {
	let prms = Q.reject();
	let nid = id;
	if (aid && id) {
		prms = assignmentService
			.deleteGraphicOrganizerNode({
				aid,
				nid
			})
			.then(result => {
				let org = model.get('graphicOrganizer');

				if (result) {
					if (org && Array.isArray(org.nodes)) {
						let nodes = org.nodes.filter(n => n.id !== id);
						nodes = sortNodes(nodes);
						org = _.assign({}, org, {
							nodes
						});
					}
					model.set('graphicOrganizer', org);
				}
				return org;
			});
	}
	return prms;
};

module.exports = {
	getGraphicOrganizer,
	createNode,
	updateNode,
	deleteNode
};
